import { Action } from '@ngrx/store';

export const FINALIZE_CODESYSTEMVERSION_DRAFT_SUCCESS = '[Vocabulary] Finalize CodeSystemVersion Draft Success';

export class FinalizeCodeSystemVersionDraftSuccessAction implements Action {
  readonly type = FINALIZE_CODESYSTEMVERSION_DRAFT_SUCCESS;

  constructor(public payload: { success: boolean }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/FinalizeCodeSystemVersionDraftSuccessAction.ts